import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { ApiError } from '@/types/api.types';
import { selectActiveAccount, useAuthStore } from '@features/auth';

import { updateClientProfile } from '../api/clientsApi';
import type { ClientProfile, UpdateClientProfileRequest } from '../types';

interface UpdateClientProfileVars {
  clientId: string;
  request: UpdateClientProfileRequest;
}

export function useUpdateClientProfile() {
  const queryClient = useQueryClient();
  const activeAccount = useAuthStore(selectActiveAccount);
  const accountId = activeAccount?.accountId ?? '';

  return useMutation<ClientProfile, ApiError, UpdateClientProfileVars>({
    mutationFn: ({ clientId, request }) => updateClientProfile(accountId, clientId, request),
    onSuccess: (_data, { clientId }) => {
      // Refresh both the list projection and the single-client profile query.
      queryClient.invalidateQueries({ queryKey: ['clients', accountId] });
      queryClient.invalidateQueries({ queryKey: ['client', accountId, clientId] });
    },
  });
}
